module.exports = __webpack_public_path__ + "img/1.2ee376b9.png";